import { List } from 'immutable'
import { AsyncState, httpResult, HttpResult, loadingAsyncState } from 'widgets-for-react'
import { AbstractParsedUpdate } from '../../public_site/custom_pages/shared/AbstractParsedUpdate'
import { getLangFromUrl, languages, updateUrlLang } from '../../public_site/utils/history.mod'
import {
  Breadcrumb,
  CustomParsedEntity,
  MenuItem,
  Pager,
  PaginatedItem,
  ParsedMenuItem,
  SearchResultItem
} from '../types_and_parser/extra_types.mod'
import {
  entity_parser,
  node_case_guard,
  node_case_parser,
  node_expertise_guard,
  node_expertise_parser,
  node_page_guard,
  node_page_parser,
  node_project_guard,
  node_project_parser,
  node_story_guard,
  node_story_parser,
  node_update_guard,
  node_update_parser,
  taxonomy_term_press_contact_guard,
  taxonomy_term_press_contact_parser,
  taxonomy_term_related_content_guard,
  taxonomy_term_related_content_parser
} from '../types_and_parser/parser.ext.gen'

export async function getDrupalNode(_slug: string): Promise<HttpResult<CustomParsedEntity> & { is_preview: boolean }> {
  const lang: string | null = _slug ? getLangFromUrl() : languages.find((x) => x.IsDefault == true)?.Value
  const localePart = `/${lang}`
  const slug = removeLangFromSlug(_slug)
  const is_preview = slug && slug.startsWith('preview')

  const url = [undefined, null, '', '/', lang].includes(slug)
    ? `/api/drupal${localePart}/api/homepage`
    : is_preview
    ? `/api/drupal${localePart}/api/${slug}` + window.location.search
    : `/api/drupal${localePart}/${slug}`

  const res = await fetch(url, {
    method: 'GET',
    credentials: 'include'
  })

  if (!res.ok) return { kind: 'failed', status: 400, is_preview }

  const json = await res.json()

  if (Array.isArray(json)) {
    if (json.length == 0) return { kind: 'failed', status: 400, is_preview }

    const parsed = entity_parser(json.shift())
    return { kind: 'result', status: 200, value: { ...parsed, locale: lang }, is_preview }
  }

  const parsed = entity_parser(json)
  return { kind: 'result', status: 200, value: { ...parsed, locale: lang }, is_preview }
}

export const getAllUpdates = (lang: string): Promise<HttpResult<PaginatedItem<AbstractParsedUpdate>>> =>
  fetch(`/api/drupal/${lang}/api/update-overview/all?page=0`)
    .then((response) => {
      if (response.ok) return response.json()
      return Promise.reject(response.statusText)
    })
    .then((data) => httpResult.success({ items: data.items, pager: data.pager }))
    .catch((reason) => {
      console.log(reason, 'failed to get updates')
      return { kind: 'failed', status: 500 }
    })

export async function getOverview<T>(
  api_name: string,
  lang: string,
  page?: number,
  taxonomy?: List<number>,
  use_comma?: boolean,
  search_query?: string
): Promise<HttpResult<PaginatedItem<T>>> {
  const res = await fetch(
    `/api/drupal${`/${lang}`}/api/${api_name}${
      search_query != undefined && search_query ? `/${search_query}` : api_name == 'update-overview' ? '/all' : ''
    }${
      taxonomy != undefined && taxonomy.count() > 0
        ? taxonomy.count() > 1
          ? `${use_comma ? '/' : '?'}${
              use_comma
                ? taxonomy.map((x) => `${x}`).join(',')
                : taxonomy.map((x, i) => `category[${i}]=${x}`).join('&')
            }`
          : `/${taxonomy.first()}`
        : ``
    }${page != null ? `?page=${page}` : ''}`,
    {
      method: 'GET',
      credentials: 'include'
    }
  )

  if (!res.ok) return { kind: 'failed', status: 400 }

  const type_parser = (t: any) =>
    taxonomy_term_related_content_guard(t)
      ? taxonomy_term_related_content_parser(t)
      : taxonomy_term_press_contact_guard(t)
      ? taxonomy_term_press_contact_parser(t)
      : node_update_guard(t)
      ? node_update_parser(t)
      : node_story_guard(t)
      ? node_story_parser(t)
      : node_expertise_guard(t)
      ? node_expertise_parser(t)
      : node_case_guard(t)
      ? node_case_parser(t)
      : node_project_guard(t)
      ? node_project_parser(t)
      : node_page_guard(t)
      ? node_page_parser(t)
      : null

  const json = await res.json()
  const pager: Pager = json['pager']
  const items = json['items']

  let parsed: PaginatedItem<T>

  if (Array.isArray(json))
    parsed = {
      pager: pager,
      items: json.map((j) => type_parser(j)) as Array<T>
    }
  else if (Array.isArray(items))
    parsed = {
      pager: pager,
      items: items.map((j) => type_parser(j)) as Array<T>
    }
  else
    parsed = {
      pager: pager,
      items: type_parser(items) as any
    }
  return { kind: 'result', status: 200, value: parsed }
}

export async function getPressReleases<T>(): // lang: string,
// page?: number,
// taxonomy?: 'all' | string
Promise<HttpResult<PaginatedItem<T>>> {
  // const locale = getLanguage(lang)
  // const res = await fetch(
  //   `/api/drupal${locale == 'global' ? '' : `/${locale}`}/api/${api_name}${
  //     taxonomy != undefined && taxonomy != 'all' ? `/${taxonomy}` : ``
  //   }${page != null ? `?page=${page}` : ''}`,
  //   {
  //     method: 'GET',
  //     credentials: 'include'
  //   }
  // )

  const res = await fetch('/api/v1/globenewswire')

  if (!res.ok) return { kind: 'failed', status: 400 }

  const json = await res.json()
  const pager = json['pager'] as Pager
  const items = json['items']

  let parsed: PaginatedItem<T>

  // if (Array.isArray(json))
  //   parsed = {
  //     pager: pager,
  //     items: List<T>(json.map((j) => type_parser(j)))
  //   }
  // else if (Array.isArray(items))
  //   parsed = {
  //     pager: pager,
  //     items: List<T>(items.map((j) => type_parser(j)))
  //   }
  // else
  //   parsed = {
  //     pager: pager,
  //     items: List<T>(type_parser(items))
  //   }

  parsed = {
    pager: pager,
    items: json
  }
  return { kind: 'result', status: 200, value: parsed }
}

export const parse_menu = (t: MenuItem[]): Array<ParsedMenuItem> => t.map(menu_item_parser)

const menu_item_parser = (t: MenuItem): ParsedMenuItem => ({
  key: t.key,
  label: t.title,
  relative: !!t.relative,
  external: t.external,
  url: t.relative ? t.relative : t.absolute,
  children: t.below ? t.below.map(menu_item_parser) : null
})

export const loadFooterColumn = async (lang: string, column: 1 | 2 | 3): Promise<HttpResult<Array<ParsedMenuItem>>> => {
  const menuList =
    window.__PRELOADED_DATA__ && window.__PRELOADED_DATA__.menus && window.__PRELOADED_DATA__.menus.footer
      ? window.__PRELOADED_DATA__.menus.footer
      : await (
          await fetch(
            `/api/drupal${lang == 'global' ? '' : `/${lang}`}/api/menu_items/footer${
              column > 1 ? `-col-${column}` : ''
            }`,
            {
              credentials: 'include'
            }
          )
        ).json()

  return {
    kind: 'result',
    status: 200,
    value: parse_menu(menuList)
  }
}

export const loadPrivacyMenu = async (lang: string): Promise<HttpResult<Array<ParsedMenuItem>>> => {
  const menuList =
    window.__PRELOADED_DATA__ && window.__PRELOADED_DATA__.menus && window.__PRELOADED_DATA__.menus.privacy
      ? window.__PRELOADED_DATA__.menus.privacy
      : await (
          await fetch(`/api/drupal${lang == 'global' ? '' : `/${lang}`}/api/menu_items/privacy`, {
            credentials: 'include'
          })
        ).json()

  return {
    kind: 'result',
    status: 200,
    value: parse_menu(menuList)
  }
}

type PreloadedData = {
  menus?: {
    top: any
    main: any
    footer: any
    privacy: any
  }
}

declare global {
  interface Window {
    __PRELOADED_DATA__: PreloadedData
  }
}

window.__PRELOADED_DATA__ = window.__PRELOADED_DATA__ || {}

export const loadHeader = async (lang: string): Promise<HttpResult<Array<ParsedMenuItem>>> => {
  // if (lang == '') {
  //   lang = defaultLanguage
  // }
  const menuList =
    window.__PRELOADED_DATA__ && window.__PRELOADED_DATA__.menus && window.__PRELOADED_DATA__.menus.main
      ? window.__PRELOADED_DATA__.menus.main
      : await (
          await fetch(`/api/drupal${lang == 'global' ? '' : `/${lang}`}/api/menu_items/main`, {
            credentials: 'include'
          })
        ).json()

  return {
    kind: 'result',
    status: 200,
    value: parse_menu(menuList)
  }
}

export const loadBreadcrumbsApiCall = async (alias: string, lang: string): Promise<HttpResult<List<Breadcrumb>>> => {
  const breadcrumbCall = await fetch(
    alias != undefined
      ? `/api/drupal${lang == 'global' ? '' : `/${lang}`}/api/breadcrumb?path=${removeLangFromSlug(alias)}`
      : '/s',
    {
      method: 'GET',
      credentials: 'include'
    }
  )
  let breadcrumbs = (await (await breadcrumbCall).json()) as Breadcrumb[]
  breadcrumbs = breadcrumbs.map((b) => ({ ...b, url: updateUrlLang(b.url, lang) }))

  return {
    kind: 'result',
    status: 200,
    value: List(breadcrumbs)
  }
}

export const loadBreadcrumbs = (alias: string, lang: string): AsyncState<List<Breadcrumb>> => {
  return loadingAsyncState(() =>
    loadBreadcrumbsApiCall(alias, lang).then<HttpResult<List<Breadcrumb>>>((bread) => {
      return bread.kind == 'result'
        ? { kind: 'result', value: bread.value.count() === 1 ? bread.value : bread.value, status: 200 }
        : { kind: 'failed', status: 404 }
    })
  )
}

const convertSearchSnippet = (content: string, introSrc: string, titleSrc: string): string => {
  let snippet = content;
  const title = titleSrc.trim();
  const intro = introSrc.trim();
  if(snippet.startsWith(title)) {
    snippet = snippet.replace(new RegExp(title), '').trim();
  }
  if(snippet.startsWith(intro)) {
    snippet = snippet.replace(new RegExp(intro), '').trim();
  }
  
  if (snippet.length > 300) {
    const snippetParts = snippet.substring(0, 300).split(' ');
    snippet = snippetParts.slice(0, -2).join(' ');
    if(!['.', '!', '?'].includes(snippet.substring(-1))) {
      snippet = snippet + ' (...)';
    }
  }

  // Decode HTML entities
  const textarea = document.createElement('textarea');
  textarea.innerHTML = snippet;
  snippet = textarea.value;

  return snippet;
}

export const search = (
  query: string,
  bundle: string,
  page: number = 0,
  pagesize: number = 10,
  lang: string,
  sort: string = 'relevance'
): AsyncState<PaginatedItem<SearchResultItem>> =>
  loadingAsyncState((_) =>
    fetch(
      `/api/v1/search?query=${query}&lang=${lang}&page=${page}&pagesize=${pagesize}${
        bundle ? `&type=${bundle}` : ''
      }&sort=${sort}`,
      { credentials: 'include' }
    ).then((res) => {
      if (!res.ok) return { kind: 'failed', status: 500 }

      window.dataLayer.push({ event: 'event', category: 'Search', action: 'Search', label: query })

      return res.json().then((json) =>
        httpResult.success({
          items: json.Results.map((item: any) => ({
            ...item,
            content: convertSearchSnippet(item.content, item.introduction, item.title)
          })),
          pager: {
            current_page: page,
            items_per_page: pagesize,
            total_items: json.Count,
            total_pages: Math.ceil(json.Count / pagesize)
          }
        })
      )
    })
  )

export const autoComplete = (prefix: string, lang: string): AsyncState<List<string>> => {
  return loadingAsyncState((_) =>
    fetch(`/api/v1/autocomplete?prefix=${prefix}&lang=${lang}`, { credentials: 'include' }).then((res) => {
      if (!res.ok)
        return {
          kind: 'failed',
          status: 500
        }

      return res.json().then((json) => ({
        kind: 'result',
        status: 200,
        value: List(json)
      }))
    })
  )
}

export const getCategoryCounts = (lang: string, query: string = ''): AsyncState<{ [key: string]: number }> =>
  loadingAsyncState((_) =>
    fetch(`/api/v1/category-counts?lang=${lang}&query=${encodeURIComponent(query)}`, { credentials: 'include' }).then(async (res) => {
      if (!res.ok) return { kind: 'failed', status: 500 }

      try {
        const json = await res.json()
        return { kind: 'result', status: res.status, value: json }
      } catch (e) {
        console.error(e)
        return { kind: 'failed', status: res.status }
      }
    })
  )

const removeLangFromSlug = (slug: string) =>
  slug
    .split('/')
    .filter((part) => part != '')
    .splice(1)
    .join('/')
